<template>
  <div class="sustainability-gdpr">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <img class="row-1-top-img desktop" src="../../assets/img/sustainability/gdpr/img_left.jpg">
        <div class="text-group">
          <h3 class="text-accent">{{ $t('sustainability-gdpr-1') }}</h3>
          <h1>{{ $t('sustainability-gdpr-2') }}</h1>
          <h2>{{ $t('sustainability-gdpr-3') }}</h2>
          <img class="row-1-top-img mobile" src="../../assets/img/sustainability/gdpr/img_left.jpg">
          <p v-html="$t('sustainability-gdpr-5')"></p>
          <p v-html="$t('sustainability-gdpr-6')"></p>
          <p>
            {{ $t('sustainability-gdpr-7') }}
            <a
              class="link-basic"
              target="_blank"
              :href="`/files/gdpr/Privacy Policy_${$i18n.locale}.pdf`"
            >{{ $t('sustainability-gdpr-7-1') }}</a>
          </p>
          <p>
            <a
              class="link-basic"
              target="_blank"
              :href="`/files/gdpr/Request to Exercise Rights_${$i18n.locale}.pdf`"
            >{{ $t('sustainability-gdpr-8') }}</a>
          </p>
        </div>
      </div>
      <div class="img-and-btn">
        <Carousel :imgs="imgs"/>
        <!-- <img src="../../assets/img/sustainability/gdpr/img_right.jpg"> -->
        <!-- <div class="btn-arrow" @click="toggleScroll()">
          <span class="kcm toggle-down">C</span>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from './Carousel';
export default {
  data() {
    return {
      imgs: [
        require('../../assets/img/sustainability/gdpr/img_right.jpg'),
        // require('../../assets/img/sustainability/gdpr/2.jpg')
      ]
    };
  },
  components: {
    Carousel
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName('btn-arrow')[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sustainability-gdpr {
  position: relative;
}
.mobile {
  display: none;
}

@media screen and (max-width: 1000px) {
  .row-1 {
    padding: $sidesPadding1280 0 0;
    flex-direction: column;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .img-and-text {
      width: 100%;
      .row-1-top-img {
        width: 100%;
      }
      .text-group {
        margin: 0;
        padding: 0 $sidesPadding1280;
      }
    }
    .img-and-btn {
      width: 100%;
      padding: 0;
      .carousel {
        height: 50vw;
      }
      .carousel,
      img {
        width: 100%;
        margin: 0;
      }
      .btn-arrow {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .row-1 {
    padding: $sidesPadding600 0 0;
    .img-and-text {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }
}
</style>
